<template>
  <div id="index">
    <transition name="filter-panel" @after-enter="onPanelEnter" @after-leave="onPanelLeave">
      <div v-if="showFilterPanel" class="filter-panel" @click.self="closeFilterPanel">
        <transition name="panel-content">
          <div v-if="showFilterPanel" class="panel-content">
            <div class="panel-header">
              <h2 class="panel-title">筛选条件</h2>
              <div class="close-btn" @click="closeFilterPanel">✕</div>
            </div>

            <div class="station-type">
              <el-radio-group v-model="stationType" @change="handleStationTypeChange">
                <el-radio-button label="existing">已有站点</el-radio-button>
                <el-radio-button label="candidate">备选站点</el-radio-button>
              </el-radio-group>
            </div>

            <div class="filter-section" v-if="stationType == 'existing'">
              <div class="filter-item">
                <div class="filter-label">分类</div>
                <el-select
                    v-model="filterLevel1"
                    placeholder="请选择"
                    class="filter-select"
                    @change="handleLevel1Change"
                    clearable
                >
                  <el-option
                      v-for="item in level1Options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-label">分类</div>
                <el-select
                    v-model="filterLevel2"
                    placeholder="请选择"
                    class="filter-select"
                    :disabled="!filterLevel1"
                    @change="handleLevel2Change"
                    clearable
                >
                  <el-option
                      v-for="item in level2Options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-label">分类</div>
                <el-select
                    v-model="filterLevel3"
                    placeholder="请选择"
                    class="filter-select"
                    :disabled="!filterLevel2"
                    @change="handleLevel3Change"
                    clearable
                >
                  <el-option
                      v-for="item in level3Options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </div>
            </div>

            <div v-if="stations.length > 0" class="station-list-section">
              <h3 class="station-list-title">
                站点列表 <span class="station-count">({{ stations.length }})</span>
              </h3>
              <div class="station-list">
                <div
                    v-for="station in stations"
                    :key="station.tooltipText"
                    class="station-item"
                    @click="centerMap(station.coordinates[1], station.coordinates[0])"
                >
                  <div class="station-name">{{ station.tooltipText }}</div>
<!--                  <div class="station-info">
                    类型: {{ station.type === 'existing' ? '已有站点' : '备选站点' }}
                  </div>
                  <div class="station-info">
                    地区: {{ station.level1 }} {{ station.level2 }} {{ station.level3 }}
                  </div>-->
                </div>
              </div>
            </div>

            <div v-else-if="loading" class="loading">
              <i class="el-icon-loading loading-spinner"></i> 加载中...
            </div>

            <div v-else-if="filterApplied" class="empty-data">
              暂无符合条件的数据
            </div>

            <div v-else class="empty-data">
              请设置筛选条件查看站点信息
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <div class="mobile-map-container">
      <div id="map" class="leaflet-map"></div>

      <div class="top-toolbar">
        <div class="search-container">
          <el-input
              v-model="searchKeyword"
              placeholder="搜索站点"
              class="search-input"
              @keyup.enter="handleSearch"
          />
          <div class="search-button" @click="handleSearch" title="搜索">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </div>
        </div>

        <div class="filter-button" @click="openFilterPanel" title="筛选">
          <svg viewBox="0 0 24 24">
            <path fill="currentColor"
                  d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"/>
          </svg>
        </div>
      </div>

      <div class="operation-bar">
        <div class="vertical-button-group">
          <button class="operation-button" @click="locateMe" title="定位到当前位置">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
            </svg>
          </button>

          <button class="operation-button" @click="goToDrawPage" title="绘图工具">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
          </button>

          <button class="operation-button" @click="zoomIn" title="放大地图">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
            </svg>
          </button>

          <button class="operation-button" @click="zoomOut" title="缩小地图">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 13H5v-2h14v2z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import router from '../../router';
import {getAllAlternativeSites, getMainList} from '../../api/holdMy.js'

// , proIndex, dockIndex, countIndex, ChartIndex
export default {
  data() {
    return {
      map: null,

      searchKeyword: '',

      showFilterPanel: false,
      stationType: 'existing',
      filterLevel1: '',
      filterLevel2: '',
      filterLevel3: '',
      level1Options: [],
      level2Options: [],
      level3Options: [],
      stations: [],
      loading: false,
      filterApplied: false,

      // 原始数据
      dataList: {},
      allList: [],
      chargeStationList: [],
      alternativeStationList: [],
      alternativeDataList:[],
      shipList: [],
      gardenAreaList: [],
      markersData: [],
      screenVal: 'all',
      selectedValues: [],
      selectedRanges: [],

      // 聚类配置
      markers: [],
      markerCluster: null,
      clusterRadius: 30,
    };
  },
  mounted() {
    this.initMap();
    this.loadFilterOptions();
    this.getMain();
  },
  beforeDestroy() {
    //this.clearDestroy()
    if (this.map) {
      this.map.remove()
    }
    //this.clearLabels()
  },
  destroyed() {

  },
  methods: {
    initMap() {
      //地图初始化，地图中心点设置在厦门，去掉自带的放大缩小控制按钮
      this.map = L.map('map', {
        center: [24.4798, 118.0894],
        zoom: 12,
        zoomControl: false
      });

      // 添加卫星图层 - 使用高德卫星地图
      let gaodeSatellite = L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}', {
        subdomains: ['1', '2', '3', '4'],
        attribution: '卫星地图'
      }).addTo(this.map)

      // 高德矢量底图
      let gaodeVector = L.tileLayer(
          'https://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}', {
            name: "矢量底图",
            subdomains: ["1", "2", "3", "4"],
          }
      ).addTo(this.map)

      // 高德路网注记
      let gaodeLabel = L.tileLayer(
          'https://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}', {
            name: "路网底图",
            subdomains: ["1", "2", "3", "4"],
          }
      ).addTo(this.map)

      // 添加标注图层（可选，显示地名等）
      /*L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}', {
        subdomains: ['1', '2', '3', '4']
      }).addTo(this.map)*/

      let baseLayers = {
        "卫星": gaodeSatellite,
        "矢量": gaodeVector
      };
      let overlayLayers = {
        "路网": gaodeLabel
      };
      L.control.layers(
          baseLayers,        // 基础底图层（互斥切换）
          overlayLayers,     // 叠加图层（勾选显示）
          {
            position: 'bottomright', // 控件位置：右上角（不遮挡默认缩放控件）
            collapsed: false      // 可选：false=默认展开控件，true=默认折叠
          }
      ).addTo(this.map);

      //普通图层
      //this.markerLayer = L.layerGroup().addTo(this.map);

      // 聚类图层
      this.initMarkerCluster();

      //多边形图层
      this.polygonsLayer = L.featureGroup().addTo(this.map);

      //去掉插件logo
      this.map.attributionControl.remove();
      this.map.attributionControl.setPrefix('');
    },

    initMarkerCluster() {
      // 初始化聚类图层
      this.markerCluster = new L.markerClusterGroup({
        maxClusterRadius: parseInt(this.clusterRadius),
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: true,
        zoomToBoundsOnClick: true,
        chunkedLoading: true,
        chunkInterval: 200,
        spiderLegPolylineOptions: {
          weight: 1.5,
          color: '#4da6ff',
          opacity: 0.5
        },
        iconCreateFunction: (cluster) => {
          const count = cluster.getChildCount();
          let size = 40;
          let className = 'cluster-1';

          if (count < 5) {
            size = 30;
            className = 'cluster-1';
          } else if (count < 10) {
            size = 40;
            className = 'cluster-5';
          } else if (count < 20) {
            size = 50;
            className = 'cluster-10';
          } else {
            size = 60;
            className = 'cluster-20';
          }

          var iconUrl = require("../../assets/icons/120/电厂.png");
          return L.divIcon({
            iconUrl: iconUrl,
            html: `<div class="cluster-count">${count}</div>`,
            className: `marker-cluster ${className}`,
            iconSize: L.point(size, size),
            iconAnchor: L.point(size/2, size/2)
          });
        }
      });

      this.markerCluster.addTo(this.map);
    },

    // 获取全部数据
    getMain() {
      let data = {}
      getMainList(data)
          .then((res) => {
            if (res.code == 200) {
              this.$set(this, 'dataList', res.data)
              this.setAllList()
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },

    // 构造数据
    setAllList(filter) {
      //侧边弹窗的数据列表
      this.stations = []

      // 合并数据到一个数组
      this.allList = []
      this.chargeStationList = []
      this.gardenAreaList = []
      this.carList = []

      if(!filter || filter == undefined || filter.level1 === "" || filter.level1 === "chargeStation") {
        this.dataList.chargeStationList.forEach((item) => {
          let isShow = true;
          if(filter && filter.level1 === "chargeStation") {
            //充电桩规格，单独处理
            if (filter.level2 === "chargingPileSpecValue") {
              let hasFlag = false;
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filter.level3 === "" || filter.level3 == parseInt(item.jnChargePileList[i].chargingPileSpecValue, 10)) {
                  hasFlag = true;
                  break;
                }
              }

              if (hasFlag) {
                isShow = true;
              } else {
                isShow = false;
              }
            }
            //其他条件直接对比数值是否相等
            else if (filter.level2 === "" || filter.level3 === "" || filter.level3 == item[filter.level2]) {
              isShow = true;
            } else {
              isShow = false;
            }
          }

          if (!isShow) {
            //如果不显示，则跳过本次迭代
            return;
          }

          let iconUrl = null;
          let pileNum = 0;//充电桩总量
          item.jnChargePileList.forEach((item) => {
            pileNum += item.chargingPileNum;
          });
          if (item.keynoteFlag == '0') {
            iconUrl = require("../../assets/icons/120/充电站.png");
          } else if (item.keynoteFlag == '1') {
            iconUrl = require("../../assets/icons/120/充电站yellow.png");
          } else if (item.keynoteFlag == '2') {
            iconUrl = require("../../assets/icons/120/充电站red.png");
          }
          var location = require('coordtransform').wgs84togcj02(item.longitude, item.latitude);
          // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);

          let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
              "<div>名称:" + item.name + '</div>';
          if (item.allChargingPileStr) {
            content += '<div>充电桩：' + item.allChargingPileStr + '</div>';
          }
          if (item.address) {
            content += '<div>地址：' + item.address + '</div>'
          }
          if (item.sysAttachmentList) {
            let imageUrlList = [];
            item.sysAttachmentList.forEach(image => {
              imageUrlList.push("/dev-api" + image.attachmentName)//prod-api
              content += "<el-image src='" + "/dev-api" + image.attachmentName + "'>"
            })

          }

          content += '</el-card>';

          let station = {
            chargeStationTypeValue: item.chargeStationTypeValue,
            coordinates: [location[0], location[1]],
            // iconUrl: item.type == '1' ? require(`../../assets/map/Bulk-cargo-terminal.${item.keynoteFlag == 1 ? 'gif' : 'png'}`) : require(`../../assets/map/wharf.${item.keynoteFlag == 1 ? 'gif' : 'png'}`),
            iconUrl: iconUrl,
            keynoteFlag: item.keynoteFlag,
            pileNum: pileNum,
            chargeStationStatusValue: item.chargeStationStatusValue,
            tooltipText: item.name,
            popupContent: content
          };

          this.chargeStationList.push(station);
          this.stations.push(station)
        })
      }

      if(!filter || filter == undefined || filter.level1 === "" || filter.level1 === "gardenArea") {
        this.dataList.gardenAreaList.forEach((item) => {
          let isShow = true;
          if(filter && filter.level1 === "gardenArea") {
            //充电桩规格，单独处理
            if (filter.level2 === "chargingPileSpecValue") {
              let hasFlag = false;
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filter.level3 === "" || filter.level3 == parseInt(item.jnChargePileList[i].chargingPileSpecValue, 10)) {
                  hasFlag = true;
                  break;
                }
              }

              if (hasFlag) {
                isShow = true;
              } else {
                isShow = false;
              }
            }
            //其他条件直接对比数值是否相等
            else if (filter.level2 === "" || filter.level3 === "" || filter.level3 == item[filter.level2]) {
              isShow = true;
            } else {
              isShow = false;
            }
          }

          if (!isShow) {
            //如果不显示，则跳过本次迭代
            return;
          }


          let iconUrl = null;
          if (item.keynoteFlag == '2') {
            if (item.gardenAreaTypeValue == '0') {
              iconUrl = require("../../assets/icons/120/港口.png")
            } else if (item.gardenAreaTypeValue == '1') {
              iconUrl = require("../../assets/icons/120/非煤矿山.png")
            } else if (item.gardenAreaTypeValue == '2') {
              iconUrl = require("../../assets/icons/120/停车场.png")
            } else if (item.gardenAreaTypeValue == '3') {
              iconUrl = require("../../assets/icons/120/物流.png");
            } else if (item.gardenAreaTypeValue == '4') {
              iconUrl = require("../../assets/icons/120/工厂.png");
            } else if (item.gardenAreaTypeValue == '5') {
              iconUrl = require("../../assets/icons/120/电厂.png");
            } else if (item.gardenAreaTypeValue == '6') {
              iconUrl = require("../../assets/icons/120/水泥拌合站.png");
            } else if (item.gardenAreaTypeValue == '7') {
              iconUrl = require("../../assets/icons/120/工厂.png");
            } else if (item.gardenAreaTypeValue == '8') {
              iconUrl = require("../../assets/icons/120/钢铁厂.png");
            } else if (item.gardenAreaTypeValue == '9') {
              iconUrl = require("../../assets/icons/120/建材.png");
            } else {
              iconUrl = require("../../assets/icons/120/gongyeyuanqu.png")
            }
          } else {
            if (item.gardenAreaTypeValue == '0') {
              iconUrl = require("../../assets/icons/60/港口.png")
            } else if (item.gardenAreaTypeValue == '1') {
              iconUrl = require("../../assets/icons/60/非煤矿山.png")
            } else if (item.gardenAreaTypeValue == '2') {
              iconUrl = require("../../assets/icons/60/停车场.png")
            } else if (item.gardenAreaTypeValue == '3') {
              iconUrl = require("../../assets/icons/60/物流.png");
            } else if (item.gardenAreaTypeValue == '4') {
              iconUrl = require("../../assets/icons/60/工厂.png");
            } else if (item.gardenAreaTypeValue == '5') {
              iconUrl = require("../../assets/icons/60/电厂.png");
            } else if (item.gardenAreaTypeValue == '6') {
              iconUrl = require("../../assets/icons/60/水泥拌合站.png");
            } else if (item.gardenAreaTypeValue == '7') {
              iconUrl = require("../../assets/icons/60/工厂.png");
            } else if (item.gardenAreaTypeValue == '8') {
              iconUrl = require("../../assets/icons/60/钢铁厂.png");
            } else if (item.gardenAreaTypeValue == '9') {
              iconUrl = require("../../assets/icons/60/建材.png");
            } else {
              iconUrl = require("../../assets/icons/60/gongyeyuanqu.png")
            }
          }
          var location = require('coordtransform').wgs84togcj02(item.longitude, item.latitude);
          // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);
          let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
              "<div>名称:" + item.name + '</div>';
          if (item.address) {
            content += '<div>地址：' + item.address + '</div>'
          }

          content += '</el-card>';

          let station = {
            coordinates: [location[0], location[1]],
            iconUrl: iconUrl,
            tooltipText: item.name,
            keynoteFlag: item.keynoteFlag,
            popupContent: content,
          };

          this.gardenAreaList.push(station);
          this.stations.push(station);
        })
      }

      if(!filter || filter == undefined || filter.level1 === "" || filter.level1 === "transportRoute") {
        this.dataList.carList.forEach((item) => {
          let isShow = true;
          if(filter && filter.level1 === "transportRoute") {
            //充电桩规格，单独处理
            if (filter.level2 === "chargingPileSpecValue") {
              let hasFlag = false;
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filter.level3 === "" || filter.level3 == parseInt(item.jnChargePileList[i].chargingPileSpecValue, 10)) {
                  hasFlag = true;
                  break;
                }
              }

              if (hasFlag) {
                isShow = true;
              } else {
                isShow = false;
              }
            }
            //其他条件直接对比数值是否相等
            else if (filter.level2 === "" || filter.level3 === "" || filter.level3 == item[filter.level2]) {
              isShow = true;
            } else {
              isShow = false;
            }
          }

          if (!isShow) {
            //如果不显示，则跳过本次迭代
            return;
          }


          let iconUrl = null;
          if (item.keynoteFlag == '2') {
            iconUrl = require("../../assets/icons/120/kuangka.png");
          } else {
            iconUrl = require("../../assets/icons/60/kuangka.png");
          }
          //经纬度转化
          var location = require('coordtransform').wgs84togcj02(item.longitude, item.latitude);
          // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);

          //对折线点经纬度进行转化

          var positions = JSON.parse(item.positions);
          if (positions) {
            for (let i = 0; i < positions.length; i++) {
              let position = require('coordtransform').wgs84togcj02(positions[i][1], positions[i][0]);
              positions[i] = [position[0], position[1]];
            }
          }

          let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
              "<div>名称:" + item.carNumber + '</div>';
          if (item.address) {
            content += '<div>地址：' + item.address + '</div>'
          }

          content += '</el-card>';

          let station = {
            coordinates: [location[0], location[1]],
            positions: positions,
            iconUrl: iconUrl,
            tooltipText: item.carNumber,
            keynoteFlag: item.keynoteFlag,
            popupContent: content,
          };

          this.carList.push(station);
          this.stations.push(station);
        })
      }

      this.allList = [...this.chargeStationList, ...this.gardenAreaList, ...this.carList]
      this.screenChange(this.screenVal)
    },


    // 切换状态
    screenChange(id) {
      this.screenVal = id
      //地图上需要画的点
      this.markersData = []
      //是否画船点
      var isReloadShip = false
      if (this.screenVal == 'all') {
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.allList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
      }
      if (this.screenVal == 'gardenArea') {
        this.markersData = this.gardenAreaList
      }
      if (this.screenVal == 'chargeStation') {
        this.markersData = this.chargeStationList
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.chargeStationList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = filter;
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = filter;
        }
      }
      if (this.screenVal == 'car') {
        this.markersData = this.carList
      }

      this.addSampleMarkers();
    },

    addSampleMarkers() {
      /*const xiamenMarkers = [
        /!* { id: 1, lat: 24.4350, lng: 118.0924, name: '厦门大学', type: 'existing' } *!/
      ];*/
      //this.markerLayer.clearLayers();
      this.markerCluster.clearLayers();

      this.markersData.forEach(point => {
        this.addSingleMarker(point);
      });
    },

    addSingleMarker(markerData) {
      let iconSize = markerData.pileNum != undefined ? markerData.pileNum <= 10 ? 30 : markerData.pileNum <= 20 ? 40 : 40 : markerData.keynoteFlag == "0" ? 30 : markerData.keynoteFlag == "1" ? 40 : 40;
      let className = "";
      if (markerData.chargeStationStatusValue == "1") {
        className = "blink-icon";
      }
      let title = markerData.tooltipText.substring(0, 6);

      const icon = L.icon({
        iconUrl: markerData.iconUrl,
        className: className,
        //html: '<div>' + title + '</div>',
        iconSize: [iconSize, iconSize]
      });

      const marker = L.marker([markerData.coordinates[1], markerData.coordinates[0]], {icon: icon})
          .bindTooltip(title,{permanent: true,direction: 'top',offset: [0, -iconSize/2]})
          .bindPopup(markerData.popupContent, {offset: [0, -iconSize/10]})
          .addTo(this.markerCluster);

      //this.markerCluster.addLayer(marker);
    },

    async handleSearch() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning('请输入搜索关键词');
        return;
      }

      //this.$message.info('正在搜索...');

      try {
        const results = await this.mockSearchLocation(this.searchKeyword.trim());

        if (results.length > 0) {
          const location = results[0];
          location.lat = location.coordinates[1];
          location.lng = location.coordinates[0];
          this.map.setView([location.lat, location.lng], 15);

          const icon = L.divIcon({
            className: 'single-marker search',
            html: '<div></div>',
            iconSize: [1, 1]
          });

          const marker = L.marker([location.lat, location.lng], {icon: icon});

          const popupContent = `
					<div style="padding: 10px; max-width: 200px;">
						<h3 style="margin: 0 0 5px 0; color: #f56c6c;">搜索结果: ${location.name}</h3>
						<p style="margin: 0; color: #666; font-size: 12px;">
							坐标: ${location.lat.toFixed(4)}, ${location.lng.toFixed(4)}
						</p>
					</div>
				`;

          marker.bindPopup(popupContent).addTo(this.map);
          marker.openPopup();

          this.$message.success(`已定位到: ${location.name}`);
        } else {
          this.$message.warning('未找到相关站点');
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.$message.error('搜索失败，请稍后重试');
      }
    },

    zoomIn() {
      this.map.zoomIn();
    },

    zoomOut() {
      this.map.zoomOut();
    },

    locateMe() {
      if (!navigator.geolocation) {
        this.$message.warning('您的浏览器不支持地理位置功能');
        return;
      }

      //this.$message.info('正在获取您的位置...');

      navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            this.map.setView([lat, lng], 15);

            const icon = L.divIcon({
              className: 'single-marker location',
              html: '<div></div>',
              iconSize: [20, 20]
            });

            const marker = L.marker([lat, lng], {icon: icon});

            const popupContent = `
					<div style="padding: 10px; max-width: 200px;">
						<h3 style="margin: 0 0 5px 0; color: #e6a23c;">您的位置</h3>
						<p style="margin: 0; color: #666; font-size: 12px;">
							坐标: ${lat.toFixed(4)}, ${lng.toFixed(4)}
						</p>
					</div>
				`;

            marker.bindPopup(popupContent).addTo(this.map);
            marker.openPopup();

            this.$message.success('已定位到您的位置');
          },
          (error) => {
            console.error('获取位置失败:', error);
            this.$message.error('获取位置失败，请检查权限设置');
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
      );
    },

    goToDrawPage() {
      router.push("/mapDraw");
    },

    openFilterPanel() {
      this.showFilterPanel = true;
    },

    closeFilterPanel() {
      this.showFilterPanel = false;
    },

    onPanelEnter() {
      document.body.style.overflow = 'hidden';
    },

    onPanelLeave() {
      document.body.style.overflow = 'auto';
    },

    async loadFilterOptions() {
      try {
        this.level1Options = await this.mockGetFilterOptions(1);
      } catch (error) {
        console.error('加载筛选选项失败:', error);
      }
    },

    async handleStationTypeChange() {
      if(this.stationType == "existing"){//已有站点
        this.polygonsLayer.clearLayers();
        await this.loadStations();
      }else{//备选站点
        this.markerCluster.clearLayers();
        await this.loadAlternativeStations();
      }
    },

    async handleLevel1Change(value) {
      this.filterLevel2 = '';
      this.filterLevel3 = '';
      this.level2Options = [];
      this.level3Options = [];

      if (value) {
        this.level2Options = await this.mockGetFilterOptions(2, value);
      }

      await this.loadStations();
    },

    async handleLevel2Change(value) {
      this.filterLevel3 = '';
      this.level3Options = [];

      if (value) {
        this.level3Options = await this.mockGetFilterOptions(3, value);
      }

      await this.loadStations();
    },

    async handleLevel3Change() {
      await this.loadStations();
    },

    async loadStations() {
      this.loading = true;
      this.filterApplied = true;

      try {
        const filters = {
          level1: this.filterLevel1,
          level2: this.filterLevel2,
          level3: this.filterLevel3
        };

        debugger
        /*this.stations = await this.mockGetStations(this.stationType, filters);

        this.updateMapWithStations(this.stations);*/
        this.setAllList(filters);
      } catch (error) {
        console.error('加载站点数据失败:', error);
        this.$message.error('加载数据失败');
        this.stations = [];
      } finally {
        this.loading = false;
      }
    },

    //加载备选站点
    async loadAlternativeStations() {
      //侧边弹窗的数据列表
      this.stations = [];
      //主页面地图点数据
      this.markersData = [];
      this.markerCluster.clearLayers();

      let data = {}
      getAllAlternativeSites(data)
          .then((res) => {
            if (res.code == 200) {
              this.$set(this, 'alternativeDataList', res.rows)
              this.setAlternativeAllList()
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },

    setAlternativeAllList() {
      this.alternativeDataList.forEach((item) => {
        let iconUrl = require("../../assets/icons/120/充电站.png");

        var location = require('coordtransform').wgs84togcj02(item.longitude, item.latitude);
        let positions = JSON.parse(item.positions);

        //计算面积
        let area = Math.round((this.calculateArea(positions)));
        let areaLabel = area + "㎡";

        // 计算亩数
        let areaMu = (area * 0.0015).toFixed(2) + "亩";

        // 计算各边长度
        let sideLengths = this.calculateSideLengths(positions);

        // 计算周长
        let perimeter = (sideLengths.reduce((sum, side) => sum + side.distance, 0));
        let perimeterLabel = "";
        if (perimeter < 1000) {
          perimeterLabel = Math.round(perimeter) + "米";
        } else {
          perimeterLabel = (perimeter / 1000).toFixed(2) + "公里";
        }

        let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
            "<div>名称：" + item.name + '</div>';
        if (item.landStatusLabel) {
          content += '<div>土地性质：' + item.landStatusLabel + '</div>';
        }
        if (item.landUseYear) {
          content += '<div>土地使用年限：' + item.landUseYear + '年</div>'
        }
        if (area) {
          content += '<div>面积：' + areaLabel + '(' + areaMu + ')' + '</div>'
        }
        if (perimeter) {
          content += '<div>周长：' + perimeterLabel + '</div>'
        }
        if (item.sysAttachmentList && item.sysAttachmentList.length > 0) {
          let imageUrlList = [];
          item.sysAttachmentList.forEach(image => {
            imageUrlList.push("/dev-api" + image.attachmentName)//prod-api
            content += "<el-image src='" + "/dev-api" + image.attachmentName + "'>"
          })

        }

        content += '</el-card>';

        let station = {
          id: item.id,
          iconUrl: iconUrl,
          positions: item.positions,
          coordinates: [
            parseFloat(item.longitude),
            parseFloat(item.latitude)
          ],
          tooltipText: item.name,
          popupContent: content
        };

        this.alternativeStationList.push(station);
        this.stations.push(station)
      });

      this.polygonsLayer.clearLayers();
      this.alternativeStationList.forEach(point => {
        this.addSingleAlternativeStation(point);
      });
    },

    addSingleAlternativeStation(markerData) {
      debugger
      let iconSize = 30;
      let className = "blink-icon";
      let title = markerData.tooltipText.substring(0, 6);

      const polygon = L.polygon(JSON.parse(markerData.positions), {
        color: 'blue',
        fillColor: 'skyblue',
        fillOpacity: 0.5
      }).addTo(this.polygonsLayer);

      const icon = L.icon({
        iconUrl: markerData.iconUrl,
        className: className,
        //html: '<div>' + title + '</div>',
        iconSize: [iconSize, iconSize]
      });

      const marker = L.marker([markerData.coordinates[1], markerData.coordinates[0]], {icon: icon})
          .bindTooltip(title,{permanent: true,direction: 'top',offset: [0, -iconSize/2]})
          .bindPopup(markerData.popupContent, {offset: [0, -iconSize/10]})
          .addTo(this.polygonsLayer);
    },

    calculateArea(latlngs) {
      const R = 6371000
      let area = 0

      if (latlngs.length > 2) {
        for (let i = 0; i < latlngs.length; i++) {
          const p1 = latlngs[i]
          const p2 = latlngs[(i + 1) % latlngs.length]
          area += (parseFloat(p2[1]) - parseFloat(p1[1])) * Math.PI / 180 *
              (2 + Math.sin(parseFloat(p1[0]) * Math.PI / 180) +
                  Math.sin(parseFloat(p2[0]) * Math.PI / 180))
        }
        area = Math.abs(area * R * R / 2)
      }

      return area
    },

    calculateSideLengths(latlngs) {
      let sideLengths = []

      for (let i = 0; i < latlngs.length; i++) {
        const p1 = latlngs[i]
        const p2 = latlngs[(i + 1) % latlngs.length]

        // 计算距离
        const distance = this.calculateDistance(p1, p2)

        // 计算方位角
        let angle = null
        if (latlngs.length > 2) {
          angle = this.calculateAngle(p1, p2)
        }

        sideLengths.push({
          distance: distance,
          angle: angle,
          from: { lat: parseFloat(p1[0]), lng: parseFloat(p1[1]) },
          to: { lat: parseFloat(p2[0]), lng: parseFloat(p2[1]) }
        })
      }

      return sideLengths;
    },

    calculateDistance(latlng1, latlng2) {
      const R = 6371000
      const lat1 = parseFloat(latlng1[0]) * Math.PI / 180
      const lat2 = parseFloat(latlng2[0]) * Math.PI / 180
      const deltaLat = (parseFloat(latlng2[0]) - parseFloat(latlng1[0])) * Math.PI / 180
      const deltaLng = (parseFloat(latlng2[1]) - parseFloat(latlng1[1])) * Math.PI / 180

      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
          Math.cos(lat1) * Math.cos(lat2) *
          Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

      return R * c
    },

    calculateAngle(p1, p2) {
      const lat1 = parseFloat(p1[0]) * Math.PI / 180
      const lat2 = parseFloat(p2[0]) * Math.PI / 180
      const lon1 = parseFloat(p1[1]) * Math.PI / 180
      const lon2 = parseFloat(p2[1]) * Math.PI / 180

      const y = Math.sin(lon2 - lon1) * Math.cos(lat2)
      const x = Math.cos(lat1) * Math.sin(lat2) -
          Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)

      let angle = Math.atan2(y, x) * 180 / Math.PI
      angle = (angle + 360) % 360

      return angle
    },

    updateMapWithStations(stations) {
      this.markerCluster.clearLayers();
      this.markers = [];

      stations.forEach(station => {
        this.addSingleMarker(station);
      });

      if (stations.length > 0) {
        const avgLat = stations.reduce((sum, s) => sum + s.lat, 0) / stations.length;
        const avgLng = stations.reduce((sum, s) => sum + s.lng, 0) / stations.length;
        this.map.setView([avgLat, avgLng], 12);
      }
    },

    centerMap(lat, lng) {
      this.map.setView([lat, lng], 15);
      this.closeFilterPanel();
    },

    mockSearchLocation(keyword) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.stations.forEach((item) => {
            if (item.tooltipText.indexOf(keyword) >= 0) {
              resolve([{
                name: keyword,
                ...item
              }]);
            }
          });
          resolve([]);
        }, 500);
      });
    },

    mockGetStations(type, filters) {
      return new Promise((resolve) => {
        setTimeout(() => {
          /*const xiamenStations = [
            /!* { id: 1, name: '厦门大学站', lat: 24.4350, lng: 118.0924, type: 'existing', level1: '福建', level2: '厦门', level3: '思明区' } *!/
          ];

          let filteredStations = xiamenStations.filter(station => {
            if (type && station.type !== type) return false;
            if (filters.level1 && station.level1 !== filters.level1) return false;
            if (filters.level2 && station.level2 !== filters.level2) return false;
            if (filters.level3 && station.level3 !== filters.level3) return false;
            return true;
          });

          resolve(filteredStations);*/
          debugger

        }, 300);
      });
    },

    mockGetFilterOptions(level, parentValue) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const options = {
            level1: [
              {value: 'chargeStation', label: '充电站'},
              {value: 'gardenArea', label: '园区'},
              {value: 'transportRoute', label: '运输路线'}

            ],
            level2: {
              'chargeStation': [
                {value: 'chargeStationTypeValue', label: '充电站类型'},
                {value: 'manufacturer', label: '充电站厂家'},
                {value: 'keynoteFlag', label: '重点项目'},
                {value: 'propertyRightValue', label: '产权'},
                {value: 'chargeStationStatusValue', label: '站点状态'},
                {value: 'landStatusValue', label: '土地性质'},
                {value: 'area', label: '充电站面积(平方米)'},
                {value: 'chargingPileSpecValue', label: '充电桩规格'}
              ],
              'gardenArea': [
                {value: 'gardenAreaTypeValue', label: '园区类型'},
                {value: 'keynoteFlag', label: '重点项目'},
                {value: 'freightPropValue', label: '货物类型'}
              ],
              'transportRoute': [
                {value: 'carTypeValue', label: '重卡类型'}
              ]
            },
            level3: {
              'stationName': [
                {value: 'text', label: '模糊查询'}
              ],
              'chargeStationTypeValue': [
                {value: 0, label: '巨能'},
                {value: 1, label: '非巨能'}
              ],
              'manufacturer': [
                {value: 0, label: '远乐'},
                {value: 1, label: '特来电'},
                {value: 2, label: '星星充电'},
                {value: 3, label: '云快充'},
                {value: 4, label: '小鹏汽车'},
                {value: 5, label: '启源芯动力'},
                {value: 6, label: '扬充'},
                {value: 7, label: '卢川'},
                {value: 8, label: '巨能充'}
              ],
              'keynoteFlag': [
                {value: 0, label: '普通项目', icon: require('../../assets/icons/60/充电站.png')},
                {value: 1, label: '重点项目', icon: require('../../assets/icons/60/充电站yellow.png')},
                {value: 2, label: '超重点项目', icon: require('../../assets/icons/60/充电站red.png')}
              ],
              'propertyRightValue': [
                {value: 0, label: '明确'},
                {value: 1, label: '未定'}
              ],
              'chargeStationStatusValue': [
                {value: 0, label: '在建', icon: require('../../assets/icons/60/充电站.png')},
                {value: 1, label: '使用中', icon: require('../../assets/icons/60/充电站.png'), isblink: true}
              ],
              'landStatusValue': [
                {value: 0, label: '工业'},
                {value: 1, label: '商业'},
                {value: 2, label: '建筑用地'},
                {value: 3, label: '集体'},
                {value: 4, label: '矿产资源用地'}
              ],
              'area': [
                {value: 'range', label: '填写范围', isInput: true, min: null, max: null}
              ],
              'chargingPileSpecValue': [
                {value: 0, label: '320KW'},
                {value: 1, label: '360KW'},
                {value: 2, label: '400KW'},
                {value: 3, label: '160KW'},
                {value: 4, label: '240KW'},
                {value: 5, label: '800KW'}
              ],

              'gardenAreaTypeValue': [
                {value: 0, label: '港口', icon: require('../../assets/icons/60/港口.png')},
                {value: 1, label: '矿山', icon: require('../../assets/icons/60/kuangshan.png')},
                {value: 2, label: '停车场', icon: require('../../assets/icons/60/停车场.png')},
                {value: 3, label: '物流园区', icon: require('../../assets/icons/60/物流.png')},
                {value: 4, label: '工厂', icon: require('../../assets/icons/60/gongyeyuanqu.png')},
                {value: 5, label: '电厂', icon: require('../../assets/icons/60/电厂.png')},
                {value: 6, label: '水泥厂', icon: require('../../assets/icons/60/水泥拌合站.png')},
                {value: 7, label: '造纸厂', icon: require('../../assets/icons/60/工厂.png')},
                {value: 8, label: '钢铁厂', icon: require('../../assets/icons/60/钢铁厂.png')},
                {value: 9, label: '建材', icon: require('../../assets/icons/60/建材.png')}
              ],
              /*'keynoteFlag': [
                {value: 0, label: '普通项目'},
                {value: 1, label: '重点项目'},
                {value: 2, label: '超重点项目'}
              ],*/
              'freightPropValue': [
                {value: 0, label: '电子产品'},
                {value: 1, label: '食品'},
                {value: 2, label: '煤炭'},
                {value: 3, label: '矿石'},
                {value: 4, label: '谷物'},
                {value: 5, label: '水泥'},
                {value: 6, label: '石油'},
                {value: 7, label: '化学品'},
                {value: 8, label: '液化天然气'},
                {value: 9, label: '石块'},
                {value: 10, label: '沙子'},
                {value: 11, label: '钢铁'}
              ],

              'carTypeValue': [
                {value: 0, label: '自卸车', icon: require('../../assets/icons/60/zixieche.png')},
                {value: 1, label: '牵引半挂车', icon: require('../../assets/icons/60/qianyinche.png')},
                {value: 2, label: '矿卡', icon: require('../../assets/icons/60/kuangka.png')},
                {value: 3, label: '载货车', icon: require('../../assets/icons/60/peisong.png')},
                {value: 4, label: '搅拌车', icon: require('../../assets/icons/60/jiaobanche-xian.png')},
                {value: 5, label: '水泥车', icon: require('../../assets/icons/60/shuiniche.png')}
              ]
            }
          };

          if (level === 1) {
            resolve(options.level1);
          } else if (level === 2 && parentValue) {
            resolve(options.level2[parentValue] || []);
          } else if (level === 3 && parentValue) {
            resolve(options.level3[parentValue] || []);
          } else {
            resolve([]);
          }
        }, 200);
      });
    }

  },
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  height: 100vh;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  height: 100vh;
  position: relative;
}

.mobile-map-container {
  width: 100%;
  height: 100vh;
  position: relative;
}

.leaflet-map {
  width: 100%;
  height: 100%;
  z-index: 1;
}

.top-toolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-container {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  flex: 1;
}

.search-input .el-input__inner {
  height: 40px;
  border: none;
  border-radius: 20px;
  padding-left: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: white;
}

.search-button {
  width: 40px;
  height: 40px;
  background-color: #409eff;
  border-color: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-button:hover {
  background-color: #66b1ff;
  transform: scale(1.05);
}

.search-button:active {
  background-color: #3a8ee6;
  transform: scale(0.95);
}

.search-button svg {
  width: 20px;
  height: 20px;
}

.filter-button {
  width: 40px;
  height: 40px;
  background-color: #409eff;
  border-color: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-button:hover {
  background-color: #66b1ff;
  transform: scale(1.05);
}

.filter-button:active {
  background-color: #3a8ee6;
  transform: scale(0.95);
}

.filter-button svg {
  width: 20px;
  height: 20px;
}

.operation-bar {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.vertical-button-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.operation-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #409eff;
  border: none;
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;
}

.operation-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.operation-button:active {
  transform: scale(0.95);
}

.operation-button svg {
  width: 24px;
  height: 24px;
}

.filter-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
}

.filter-panel-enter-active, .filter-panel-leave-active {
  transition: opacity 0.3s ease;
}

.filter-panel-enter, .filter-panel-leave-to {
  opacity: 0;
}

.panel-content-enter-active, .panel-content-leave-active {
  transition: transform 0.3s ease;
}

.panel-content-enter, .panel-content-leave-to {
  transform: translateX(100%);
}

.panel-content {
  width: 85%;
  max-width: 320px;
  height: 100%;
  background-color: white;
  margin-left: auto;
  padding: 20px;
  overflow-y: auto;
  box-shadow: -2px 0 20px rgba(0, 0, 0, 0.1);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.panel-title {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}

.close-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f5f7fa;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #409eff;
  color: white;
}

.station-type {
  margin-bottom: 20px;
}

.station-type .el-radio-group {
  display: flex;
  width: 100%;
}

.station-type .el-radio-button {
  flex: 1;
}

.station-type .el-radio-button__inner {
  width: 100%;
  padding: 10px 0;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-label {
  width: 60px;
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  flex-shrink: 0;
}

.filter-select {
  flex: 1;
}

.filter-select .el-select {
  width: 100%;
}

.station-list-section {
  margin-top: 20px;
}

.station-list-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.station-list {
  max-height: 300px;
  overflow-y: auto;
}

.station-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.station-item:hover {
  background-color: #f5f7fa;
  transform: translateX(5px);
}

.station-item:last-child {
  border-bottom: none;
}

.station-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  font-weight: 500;
}

.station-info {
  font-size: 12px;
  color: #909399;
}

.empty-data {
  text-align: center;
  padding: 30px 0;
  color: #c0c4cc;
}

.station-count {
  color: #409eff;
  font-weight: bold;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #409eff;
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .top-toolbar {
    top: 5px;
    left: 5px;
    right: 5px;
  }

  .operation-bar {
    bottom: 10px;
    left: 10px;
  }

  .operation-button {
    width: 45px;
    height: 45px;
  }

  .filter-label {
    width: 50px;
    font-size: 12px;
  }
}

.single-marker {
  width: 20px;
  height: 20px;
  background: #409eff;
  border: 3px solid white;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.6);
}

.single-marker.existing {
  background: #67c23a;
  box-shadow: 0 0 8px rgba(103, 194, 58, 0.6);
}

.single-marker.candidate {
  background: #409eff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.6);
}

.single-marker.search {
  background: #f56c6c;
  box-shadow: 0 0 8px rgba(245, 108, 108, 0.6);
}

.single-marker.location {
  background: #e6a23c;
  box-shadow: 0 0 8px rgba(230, 162, 60, 0.6);
}

.leaflet-div-icon {
  background: transparent;
  border: none;
}

.cluster-count {
  background-color: transparent;
  border: 3px solid #409eff;
  border-radius: 50%;
  display: flex; /* 使用Flexbox布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
</style>


